/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import {
  ToggleButtonGroup,
  ToggleButton,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogContent,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './dashboard.module.scss';
import DealCard from './dealCard';
import GaugeChart from './gaugeChart';
import PieChartDB from './pieChartDB';
import OpenDealsIcon from '../../../Assets/images/svg/dar_open_deals.svg';
import AssignedIcon from '../../../Assets/images/svg/dar_assigned.svg';
import DealsClosed from '../../../Assets/images/svg/dar_deals_closed.svg';
import NewDeals from '../../../Assets/images/svg/dar_new_deals.svg';
import HandShake from '../../../Assets/images/svg/dar_handshake.svg';
import { DEAL_TRANSITION_DASHBOARD } from '../../../Constants/strings';
import TableView from './tableView';
import DateRangeEditor from '../../../Components/CustomDateRange/dateRangeInput';
import { getCount, getValue } from '../../../Api/request/dealDashboard';
import UseAxios from '../../../Api/http/http';
import ErrorImage from '../../../Assets/images/png/dar_error.png';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Contexts/AuthContext';
import Loader from '../../../Components/Loader';
import { defaultRanges } from '../../../Components/CustomDateRange/defaultsPresetter';

const Dashboard = () => {
  const [alignment, setAlignment] = useState('Count');
  const [pieChartA, setPieChartA] = useState(null);
  const [pieChartB, setPieChartB] = useState(null);
  const [gaugeChartA, setGaugeChartA] = useState(null);
  const [gaugeChartB, setGaugeChartB] = useState(null);
  const [gaugeChartC, setGaugeChartC] = useState(null);
  const [dealCardData, setDealCardData] = useState([]);
  const [visible, setVisible] = useState(true);
  const initialDateRange = defaultRanges.find(range => range.label === 'Last 2 Months') || {};
  const [dateRange, setDateRange] = useState({
    startDate: initialDateRange.startDate,
    endDate: initialDateRange.endDate,
    label: initialDateRange.label,
  });
  const [countResponse, setCountResponse] = useState(null);
  const [valueResponse, setValueResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);

  const { userProfile } = useContext(AuthContext);
  const userId = userProfile?.id;

  const navigate = useNavigate();
  const handleCloseErrorDialog = () => {
    setErrorDialogOpen(false);
    navigate('/deal-transition/dashboard');
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { startDate, endDate } = dateRange;
        if (alignment === 'Count') {
         const count = await UseAxios(getCount(startDate, endDate, userId)); 
          if (count.data.status === 200) {
            setCountResponse(count.data.response);
          } else {
            setErrorDialogOpen(true);
          }
        } else {
          const value = await UseAxios(getValue(startDate, endDate, userId)); 
          if (value.data.status === 200) {
            setValueResponse(value.data.response);
          } else {
            setErrorDialogOpen(true);
          }
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        setErrorDialogOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [alignment, dateRange, userId]);

  const createUpdatedPlatformsA = () => [
    {
      label: 'New',
      value:
        alignment === 'Count'
          ? countResponse?.dealRenewals
          ?.new
          : valueResponse?.dealRenewals
          ?.new,
      color: '#C3EFD5',
    },
    {
      label: 'Renewal',
      value:
        alignment === 'Count'
          ? countResponse?.dealRenewals?.renewal
          : valueResponse?.dealRenewals?.renewal,
      color: '#77CD8F',
    },
  ];

  const createUpdatedPlatformsB = () => [
    {
      label: 'Won',
      value:
        alignment === 'Count'
          ? countResponse?.newVsVertical?.won
          : valueResponse?.newVsVertical?.won,
      color: '#FF9CC5',
    },
    {
      label: 'Lost',
      value:
        alignment === 'Count'
          ? countResponse?.newVsVertical?.lost
          : valueResponse?.newVsVertical?.lost,
      color: '#FFDFEC',
    },
    {
      label: 'WIP',
      value:
        alignment === 'Count'
          ? countResponse?.newVsVertical?.wip
          : valueResponse?.newVsVertical?.wip,
      color: '#FF4493',
    },
  ];

  const createUpdatedDealsByValue = () => ({
    header: 'Open deals by value',
    type1: 'Large',
    type2: 'Medium',
    type3: 'Low',
    val1:
      alignment === 'Count'
        ? countResponse?.openDealsByValue?.large
        : valueResponse?.openDealsByValue?.large,
    val2:
      alignment === 'Count'
        ? countResponse?.openDealsByValue?.medium
        : valueResponse?.openDealsByValue?.medium,
    val3:
      alignment === 'Count'
        ? countResponse?.openDealsByValue?.low
        : valueResponse?.openDealsByValue?.low,
  });

  const createUpdatedDealsByVertical = () => ({
    header: 'Open deals by verticals',
    type1: 'App mod',
    type2: 'Data mod',
    type3: 'Infra mod',
    val1:
      alignment === 'Count'
        ? countResponse?.openDealsByVertical?.appMod
        : valueResponse?.openDealsByVertical?.appMod,
    val2:
      alignment === 'Count'
        ? countResponse?.openDealsByVertical?.dataMod
        : valueResponse?.openDealsByVertical?.dataMod,
    val3:
      alignment === 'Count'
        ? countResponse?.openDealsByVertical?.infraMod
        : valueResponse?.openDealsByVertical?.infraMod,
  });
  const createUpdatedDealsByRegion = () => {
    const regionData = alignment === 'Count'
      ? countResponse?.openDealsByRegion
      : valueResponse?.openDealsByRegion;
  
    if (!regionData || Object.keys(regionData).length === 0) {
      return { header: 'Open deals by region' };
    }
  
    const keys = Object.keys(regionData);
    
  
   
    return {
      header: 'Open deals by region',
      type1: keys[0],
      val1: regionData[keys[0]] || 0,
      type2: keys[1],
      val2: regionData[keys[1]] || 0,
      type3: keys[2],
      val3: regionData[keys[2]] || 0,
      other: keys.length > 3
        ? {
            label: 'Other',
            value: keys.slice(3).reduce((sum, key) => sum + (regionData[key] || 0), 0),
          }
        : null,
    };
  };
  
  
  const createUpdatedDealCardData = () => [
    {
      title: 'Total open deals',
      value:
        alignment === 'Count'
          ? countResponse?.totalOpenDeals
          : valueResponse?.totalOpenDeals,
      gradient: 'linear-gradient(156.64deg, #C1EAED 11.08%, #A0C8FF 87.04%)',
      icon: OpenDealsIcon,
    },
    {
      title: 'Assigned to me',
      value:
        alignment === 'Count'
          ? countResponse?.assignedToMe
          : valueResponse?.assignedToMe,
      gradient: 'linear-gradient(156.64deg, #EED79C 11.08%, #FFB7A0 87.04%)',
      icon: AssignedIcon,
    },
    {
      title: 'Deals closed in past 1 month',
      value:
        alignment === 'Count'
          ? countResponse?.closedDealPastMonth
          : valueResponse?.closedDealPastMonth,
      gradient: 'linear-gradient(156.64deg, #CFC1ED 11.08%, #A0DDFF 87.04%)',
      icon: DealsClosed,
    },
    {
      title: 'New / Unassigned',
      value:
        alignment === 'Count'
          ? countResponse?.newUnassigned
          : valueResponse?.newUnassigned,
      gradient: 'linear-gradient(156.64deg, #EDC1DC 11.08%, #E0BCFD 87.04%)',
      icon: NewDeals,
    },
  ];

  useEffect(() => {
    if (countResponse || valueResponse) {
      setGaugeChartA(createUpdatedDealsByValue());
      setGaugeChartB(createUpdatedDealsByVertical());
      setGaugeChartC(createUpdatedDealsByRegion());
      setPieChartA(createUpdatedPlatformsA());
      setPieChartB(createUpdatedPlatformsB());
      setDealCardData(createUpdatedDealCardData());
    }
  }, [countResponse, valueResponse]);

  const handleToggle = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
    setVisible(false);
    setTimeout(() => {
      setVisible(true);
    }, 250);
  };

  const handleDateRangeChange = (newDateRange) => {
    setDateRange(newDateRange);
  };

  return (
    <div className={styles['dashboard-container']}>
      <div className={styles.header}>{DEAL_TRANSITION_DASHBOARD}</div>
      <Accordion className={styles.accordion} defaultExpanded={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className={styles['accordion-summary']}
        >
          Analytics
        </AccordionSummary>
        <AccordionDetails className={styles['accordion-details']}>
          <div className={styles['top-bar']}>
            <div className={styles['left-section']}>
              <div className={styles['show-analytics']}>
                Show analytics of:{'  '}
              </div>

              <div className={styles['date-range-editor-container']}>
                <DateRangeEditor
                  dateRange={dateRange}
                  onChange={handleDateRangeChange}
                  fromPlaceholder="From Date"
                  toPlaceholder="To Date"
                />
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <ToggleButtonGroup
                value={alignment}
                exclusive
                onChange={handleToggle}
                aria-label="Platform"
                className={styles['toggle-button-group']}
              >
                <ToggleButton className={styles['toggle-button']} value="Count">
                  Count
                </ToggleButton>
                <ToggleButton className={styles['toggle-button']} value="Value">
                  Value
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
          </div>

          <div className={styles.charts}>
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className={styles['left-container']}>
                  <div className={styles['deal-card-container']}>
                    {dealCardData?.map((data) => (
                      <DealCard
                        key={data.title}
                        data={data}
                        alignment={alignment}
                      />
                    ))}
                  </div>
                  <div className={styles['gauge-chart-container']}>
                    {gaugeChartA && (
                      <GaugeChart
                        data={gaugeChartA}
                        visible={visible}
                        alignment={alignment}
                      />
                    )}
                    {gaugeChartB && (
                      <GaugeChart
                        data={gaugeChartB}
                        visible={visible}
                        alignment={alignment}
                      />
                    )}
                    {gaugeChartC && (
                      <GaugeChart
                        data={gaugeChartC}
                        visible={visible}
                        alignment={alignment}
                      />
                    )}
                  </div>
                </div>
                <div className={styles['right-container']}>
                  <div className={styles['hand-shake']}>
                    <img src={HandShake} alt="HandShake" />
                    <div className={styles.deals}>Deals</div>
                  </div>
                  {pieChartA && (
                    <PieChartDB
                      data={pieChartA}
                      visible={visible}
                      alignment={alignment}
                    />
                  )}
                  {pieChartB && (
                    <PieChartDB
                      data={pieChartB}
                      visible={visible}
                      alignment={alignment}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </AccordionDetails>
      </Accordion>
      <TableView />
      <Dialog
        open={errorDialogOpen}
        onClose={handleCloseErrorDialog}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
      >
        <header className={styles['error-header']}>
          There was an error fetching the data. Please try again later.
        </header>
        <DialogContent>
          <div className={styles['error-content']}>
            <div className={styles['error-image-container']}>
              <img src={ErrorImage} alt="Error" />
            </div>
            <div className={styles['error-message']}>
              Error: Could not find data
            </div>
            <div className={styles['error-description']}>
              You don't have the necessary permissions to access this
              screen/function. Please contact our support team for assistance.
            </div>
          </div>
        </DialogContent>
        <footer className={styles['error-footer']}>
          <button
            className={styles['error-button-to-dashboard']}
            onClick={handleCloseErrorDialog}
          >
            Back to Dashboard
          </button>
        </footer>
      </Dialog>
    </div>
  );
};

export default Dashboard;
